import { ToroLocationDetailed } from '../../../api/models/toro-location-detailed.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ToroLocation } from '../../../api/models/toro-location.model';


// export function selectLocationId(location: ToroLocation): number {
//     return location.Id;
// }

export const toroLocationAdapter: EntityAdapter<ToroLocation> = createEntityAdapter<ToroLocation>({
    selectId: (location: ToroLocation) => location.Id
});

export interface ToroLocationState extends EntityState<ToroLocation> {
    total: number;
    loaded: boolean;
    currentLocation: ToroLocation,
    locationDetail: ToroLocationDetailed,
    isDefaultThemeSet: boolean,
    // ids: number[],
    // entities: any
}
